import { createSelector } from "reselect";
import { AppState } from "@shared/interfaces";

const selectClaritasState = (state: AppState) => state.claritas;
export const selectVisitors = () => createSelector(selectClaritasState, (state) => state.visitors);
export const selectStatistics = () => createSelector(selectClaritasState, (state) => state.statistics);

export const selectFilter = () => createSelector(selectClaritasState, (state) => state.filter);
